import { configureStore } from './configureStore';
import { hydrateState } from './hydrate';
import rootReducer from './rootReducer';

export type AppState = ReturnType<typeof rootReducer>;

const isServer = (): boolean => typeof window !== 'undefined';

export const store = configureStore(isServer() ? hydrateState() : undefined);
